__turbopack_context__.v({
  "Actions": "RinPJa_Actions",
  "Confirm": "RinPJa_Confirm",
  "ConfirmActions": "RinPJa_ConfirmActions",
  "ConfirmCancel": "RinPJa_ConfirmCancel",
  "ConfirmText": "RinPJa_ConfirmText",
  "ConfirmYes": "RinPJa_ConfirmYes",
  "DraftButton": "RinPJa_DraftButton",
  "Error": "RinPJa_Error",
  "Feedback": "RinPJa_Feedback",
  "PublishButton": "RinPJa_PublishButton",
  "Root": "RinPJa_Root",
  "SourceInfo": "RinPJa_SourceInfo",
  "SourceLabel": "RinPJa_SourceLabel",
  "SourcePath": "RinPJa_SourcePath",
  "Success": "RinPJa_Success",
  "UnlinkButton": "RinPJa_UnlinkButton",
  "skeleton-loading": "RinPJa_skeleton-loading",
});
